import React from 'react'
import { Header, Text } from '@crossfit/ui'

function InvalidInvitation() {
  return (
    <>
      <Header size='large' as='h2' mb={[12, 6]}>
        Sorry!
      </Header>

      <Text mb={8}>
        It looks like this invite has expired. If you believe this to be an
        error, reach out to your affiliate’s owner or manager and ask to be
        re-invited.
      </Text>
    </>
  )
}

export default InvalidInvitation
